import API from '../api/Http'
import * as EndPoints from '../api/EndPoints'
import { message } from 'antd'
import moment from 'moment'
import { RESPONSE_MESSAGE } from '../utils/constants'

const FETCH_BRAND_ACTIVITY_REQUEST = 'Brand/FETCH_BRAND_ACTIVITY_REQUEST'
const FETCH_BRAND_ACTIVITY_SUCCESS = 'Brand/FETCH_BRAND_ACTIVITY_SUCCESS'
const FETCH_BRAND_ACTIVITY_FAILURE = 'Brand/FETCH_BRAND_ACTIVITY_FAILURE'

const FETCH_BRAND_ACTIVITY_BY_ID_REQUEST =
  'Brand/FETCH_BRAND_ACTIVITY_BY_ID_REQUEST'
const FETCH_BRAND_ACTIVITY_BY_ID_SUCCESS =
  'Brand/FETCH_BRAND_ACTIVITY_BY_ID_SUCCESS'
const FETCH_BRAND_ACTIVITY_BY_ID_FAILURE =
  'Brand/FETCH_BRAND_ACTIVITY_BY_ID_FAILURE'

const CREATE_BRAND_ACTIVITY_REQUEST = 'Brand/CREATE_BRAND_ACTIVITY_REQUEST'
const CREATE_BRAND_ACTIVITY_SUCCESS = 'Brand/CREATE_BRAND_ACTIVITY_SUCCESS'
const CREATE_BRAND_ACTIVITY_FAILURE = 'Brand/CREATE_BRAND_ACTIVITY_FAILURE'

const UPDATE_BRAND_ACTIVITY_REQUEST = 'Brand/UPDATE_BRAND_ACTIVITY_REQUEST'
const UPDATE_BRAND_ACTIVITY_SUCCESS = 'Brand/UPDATE_BRAND_ACTIVITY_SUCCESS'
const UPDATE_BRAND_ACTIVITY_FAILURE = 'Brand/UPDATE_BRAND_ACTIVITY_FAILURE'

const DELETE_BRAND_ACTIVITY_REQUEST = 'Brand/DELETE_BRAND_ACTIVITY_REQUEST'
const DELETE_BRAND_ACTIVITY_SUCCESS = 'Brand/DELETE_BRAND_ACTIVITY_SUCCESS'
const DELETE_BRAND_ACTIVITY_FAILURE = 'Brand/DELETE_BRAND_ACTIVITY_FAILURE'

// Initialize State
const initialState = {
  isLoading: true,
  error: {},
  brandActivityList: [],
  brandActivityObj: {}
}

// Default Reducer
const brandActivity = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BRAND_ACTIVITY_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_BRAND_ACTIVITY_SUCCESS:
      return {
        ...state,
        isLoading: false,
        brandActivityList: action.payload
      }
    case FETCH_BRAND_ACTIVITY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case FETCH_BRAND_ACTIVITY_BY_ID_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case FETCH_BRAND_ACTIVITY_BY_ID_SUCCESS:
      return {
        ...state,
        isLoading: false,
        brandActivityObj: action.payload
      }
    case FETCH_BRAND_ACTIVITY_BY_ID_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case CREATE_BRAND_ACTIVITY_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case CREATE_BRAND_ACTIVITY_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case CREATE_BRAND_ACTIVITY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case UPDATE_BRAND_ACTIVITY_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case UPDATE_BRAND_ACTIVITY_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case UPDATE_BRAND_ACTIVITY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    case DELETE_BRAND_ACTIVITY_REQUEST:
      return {
        ...state,
        isLoading: true
      }
    case DELETE_BRAND_ACTIVITY_SUCCESS:
      return {
        ...state,
        isLoading: false
      }
    case DELETE_BRAND_ACTIVITY_FAILURE:
      return {
        ...state,
        error: action.error,
        isLoading: false
      }
    default:
      return state
  }
}

export default brandActivity

// Action Creators
export const fetchBrandActivityList = (brandId) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: FETCH_BRAND_ACTIVITY_REQUEST
      })

      const { data } = await API.post(
        EndPoints.BRAND_ACTIVITY + '/activity-list',
        { brandId: brandId, enable: false }
      )
      const addRangeDateResp = data.brandActivityList.map((brandActivity) => {
        return {
          ...brandActivity,
          rangeActiveDate: `${moment(brandActivity.effectiveDate).format(
            'D/MMMM/YYYY'
          )}-${moment(brandActivity.expirationDate).format('D/MMMM/YYYY')}`,
          status: brandActivity.enabled
            ? 'Active'
            : moment(brandActivity.expirationDate).isBefore(moment(), 'day')
              ? 'Expire'
              : 'Inactive'
        }
      })

      dispatch({
        type: FETCH_BRAND_ACTIVITY_SUCCESS,
        payload: addRangeDateResp
      })
    } catch (err) {
      dispatch({
        type: FETCH_BRAND_ACTIVITY_FAILURE
      })
    }
  }
}

export const createBrandActivity = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: CREATE_BRAND_ACTIVITY_REQUEST
      })
      await API.post(EndPoints.BRAND_ACTIVITY, data)
      dispatch({
        type: CREATE_BRAND_ACTIVITY_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: CREATE_BRAND_ACTIVITY_FAILURE
      })
    }
  }
}

export const updateBrandActivity = (data) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: UPDATE_BRAND_ACTIVITY_REQUEST
      })
      await API.put(EndPoints.BRAND_ACTIVITY, data)
      dispatch({
        type: UPDATE_BRAND_ACTIVITY_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: UPDATE_BRAND_ACTIVITY_FAILURE
      })
    }
  }
}

export const deleteBrandActivity = (id) => {
  return async (dispatch) => {
    try {
      dispatch({
        type: DELETE_BRAND_ACTIVITY_REQUEST
      })
      await API.delete(EndPoints.BRAND_ACTIVITY + `/${id}`)
      dispatch({
        type: DELETE_BRAND_ACTIVITY_SUCCESS
      })
      message.success(RESPONSE_MESSAGE.SUCCESS)
    } catch (err) {
      message.error(RESPONSE_MESSAGE.FAIL)
      dispatch({
        type: DELETE_BRAND_ACTIVITY_FAILURE
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/modules/brandActivity.js